import type { StaticPageSlug } from 'Utilities/staticPageSlugs';

import AlreadyActivated from './AlreadyActivated/AlreadyActivated';
import AuctionUnsubscribe from './AuctionUnsubscribe/AuctionUnsubscribe';
import CancellationAndPriceAdjustments from './CancellationAndPriceAdjustments/CancellationAndPriceAdjustmentsPolicy';
import CodeOfConduct from './CodeOfConduct/CodeOfConduct';
import ContactUs from './ContactUs/ContactUs';
import Cookies from './Cookies/Cookies';
import ErrorPage from './Error/Error';
import ModulrPaymentTermsText from './ModulrPaymentTerms/ModulrPaymentTerms';
import PaymentsAssurancePolicy from './PaymentsAssurancePolicy/PaymentsAssurancePolicy';
import PaymentTerms from './PaymentTerms/PaymentTerms';
import Privacy from './Privacy/Privacy';
import Terms from './Terms/Terms';

// Static page components mapping
// Only includes pages that use the /static_page route and are defined in STATIC_PAGE_SLUGS
const staticPageComponents: Record<StaticPageSlug, React.ComponentType> = {
	'activate-account': AlreadyActivated,
	'cancellation-and-price-adjustments': CancellationAndPriceAdjustments,
	'code-of-conduct': CodeOfConduct,
	'contact-us': ContactUs,
	cookies: Cookies,
	'payment-terms': PaymentTerms,
	'payments-assurance-policy': PaymentsAssurancePolicy,
	privacy: Privacy,
	terms: Terms,
};

// Additional components that don't use the /static_page route
const additionalComponents = {
	'auction-unsubscribe': AuctionUnsubscribe,
	error: ErrorPage,
	'modulr-payment-terms': ModulrPaymentTermsText,
};

// Combined export for backward compatibility
export default {
	...staticPageComponents,
	...additionalComponents,
};

// Export typed static page components separately
export { staticPageComponents };
